import { render, staticRenderFns } from "./BlockTrade.vue?vue&type=template&id=e2f3b62a&scoped=true&"
import script from "./BlockTrade.vue?vue&type=script&lang=js&"
export * from "./BlockTrade.vue?vue&type=script&lang=js&"
import style0 from "./BlockTrade.vue?vue&type=style&index=0&id=e2f3b62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f3b62a",
  null
  
)

export default component.exports